// Decide se um download precisa interagir com o usuário pra escolher
// qualidade. Função pura — não toca em UI nem dispatch. Caller (componente
// que tem acesso ao DOM/Vue) decide como renderizar o sheet baseado no
// retorno.
//
// Retorna:
//   { decision: 'use', quality } — usar a quality direto, sem prompt
//   { decision: 'prompt', mode, initialSelected, wifiDefaultQuality }
//                                — abrir DownloadQualitySheet com esses props
//   { decision: 'skip' }         — fila sem vídeo ou plataforma web; segue
//                                  sem qualidade (caller ignora o param)
//
// Lógica:
//   1. Sem vídeo OU !nativo: skip (qualidade não se aplica).
//   2. Cellular: SEMPRE prompt (cellular pergunta por fila).
//      Pré-seleção: última escolha cellular, fallback 'low'.
//   3. Wi-Fi + wifiQuality setado: use silencioso (caminho quente).
//   4. Wi-Fi + wifiQuality === null: prompt firstTime (onboarding).

const FALLBACK_QUALITY = 'low';

export function decideDownloadQuality (ctx) {
  const {
    hasVideo,
    isNative,
    isCellular,
    wifiQuality,
    lastCellularQuality
  } = ctx;

  // (1) Sem vídeo na fila: qualidade não importa. Caller deve pular gate.
  if (!hasVideo || !isNative) {
    return { decision: 'skip', quality: FALLBACK_QUALITY };
  }

  // (2) Cellular: sempre pergunta.
  if (isCellular) {
    return {
      decision: 'prompt',
      mode: 'cellular',
      initialSelected: lastCellularQuality || FALLBACK_QUALITY,
      wifiDefaultQuality: wifiQuality || null
    };
  }

  // (3) Wi-Fi com setting: silencioso.
  if (wifiQuality) {
    return { decision: 'use', quality: wifiQuality };
  }

  // (4) Wi-Fi primeira vez: onboarding.
  return {
    decision: 'prompt',
    mode: 'firstTime',
    initialSelected: 'medium',
    wifiDefaultQuality: null
  };
}
